import {layoutMarkup} from "../layout/layoutMarkup.js";
import {componentsHelper} from "../../helpers/componentsHelper.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {labeledImageDefaultContent} from './labeledImageSectionDefaultContent';
import l10n from "../../../lang/locallang";

const labeledImageSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(labeledImageDefaultContent);
    const { labeledImageTexts } = l10n;
    param.class = param.class ? param.class : 'editor-section editor-labeled-image';
    param.layout = param.layout ? param.layout : '';
    param.style = param.style ? param.style : '';
    param.section = 'labeledImageSection';
    let img_url = param.content && param.content.image_url ? param.content.image_url : '../../images/editor/CG_625252162.jpeg';

    let defaultContentValue = {
        image_url: img_url,
        image_caption: '',
        image_caption_style: 'display: none;',
        image_alt: '',
        asset_id: componentsHelper.setAssetUniqueID(null, 1, param.id, 'image'),
        labels: {
            1: {
                id: param.id + '_1',
                order: 1,
                style: 'top: 118px; left: 669px;',
                heading: labeledImageTexts[1].heading,
                text: labeledImageTexts[1].text,
                image_url: '',
                image_alt: '',
                asset_id: componentsHelper.setAssetUniqueID(null, 1, param.id, 'image'),
            },
            2: {
                id: param.id + '_2',
                order: 2,
                style: 'top: 54px; left: 45px;',
                heading: labeledImageTexts[2].heading,
                text: labeledImageTexts[2].text,
                image_url: '',
                image_alt: '',
                asset_id: '',
            },
            3: {
                id: param.id + '_3',
                order: 3,
                style: 'top: 221px; left: 37px;',
                heading: labeledImageTexts[3].heading,
                text: labeledImageTexts[3].text,
                image_url: '',
                image_alt: '',
                asset_id: componentsHelper.setAssetUniqueID(null, 3, param.id, 'image'),
            },
            4: {
                id: param.id + '_3',
                order: 4,
                style: 'top: 182px; left: 702px;',
                heading: labeledImageTexts[4].heading,
                text: labeledImageTexts[4].text,
                image_url: '',
                image_alt: '',
                asset_id: componentsHelper.setAssetUniqueID(null, 3, param.id, 'image'),
            },
            5: {
                id: param.id + '_3',
                order: 5,
                style: 'top: 325px; left: 528px;',
                heading: labeledImageTexts[5].heading,
                text: labeledImageTexts[5].text,
                image_url: '',
                image_alt: '',
                asset_id: componentsHelper.setAssetUniqueID(null, 3, param.id, 'image'),
            }
        }

    }
    let image_url = param.content && param.content.image_url ? param.content.image_url : defaultContentValue.image_url;
    let image_caption = param.content && param.content.image_caption ? param.content.image_caption : defaultContentValue.image_caption;
    let image_caption_style = param.content && param.content.image_caption_style ? '' : 'display: none;';
    let image_alt = param.content && param.content.image_alt ? param.content.image_alt : defaultContentValue.image_alt;
    let asset_id = param.content && param.content.asset_id ? param.content.asset_id : defaultContentValue.asset_id;
    const { removeMarker, addImage, previous, next, imageCaption } = l10n.editor;

    let labelsList = param.content && param.content.labels ? Object.values(param.content.labels) : defaultContentValue.labels;

    let labelsHTML = '';

    if(labelsList){
       // let labelsList = Object.values(param.labels);
        for(let key in labelsList){
            let label = labelsList[key];
            labelsHTML += `
                <div class="li-label-item" data-label="${label.order}" id="${label.id}" style="${label.style}">
                    <div class="li-label-marker">
                        <span></span>
                    </div>
                    <div class="li-label">
                        <span class="li-label-corner"></span>
                        <div class="li-label_action">
                            <div class="col">
                                <input type="file" id="file_img_${label.id}" accept="image/png, image/gif, image/jpeg">
                                <button class="label-action-btn" data-action="remove" aria-label="${removeMarker}" title="${removeMarker}"><i class="icon icon-trash"></i></button>
                                <button class="label-action-btn" data-action="img" aria-label="${addImage}" title="${addImage}"><i class="icon icon-img"></i></button>
                            </div>
                            <div class="col">
                                <button class="label-action-btn" data-action="prev" aria-label="${previous}" title="${previous}"><i class="icon icon-chevron-left"></i></button>
                                <button class="label-action-btn" data-action="next" aria-label="${next}" title="${next}"><i class="icon icon-chevron-right"></i></button>
                            </div>
                        </div>
                        <div class="li-label_img ${!label.image_url ? `no-image` : ``}">
                            <div class="li-label_img_del">
                                <i class="icon icon-remove"></i>
                            </div>
                            ${label.image_url ? `<img src="${label.image_url}" data-asset-id="${label.asset_id}" alt="Img">` : `<img src="" alt="Img">`}
                        </div>
                        <div class="li-label_title">
                            <h4 contenteditable="true" class="__editable">${label.heading}</h4>
                        </div>
                        <div class="li-label_content">
                            <p contenteditable="true" class="__editable">${label.text}</p>
                        </div>
                        <div class="li-label-notification"></div>
                    </div>
                </div>`;
        }
    }

    param.component = `
        <div class="labeled-image">
            <div class="labeled-image_img image-container_figure">
                <img src="${image_url}" alt="${image_alt}" data-asset-id="${asset_id}">
                <figcaption class="image-container_caption" placeholder="${imageCaption}" contenteditable="true">${image_caption}</figcaption>
            </div>
            <div class="labeled-image_markers">${labelsHTML}</div>
        </div>`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {labeledImageSection};

